import { injectBaseConstantMethods } from "./BaseConstants";

export const SUBSCRIPTION_STATUS = {
    PREMIUM: "PREMIUM",
    FREEMIUM: "FREEMIUM",
    ALL: "ALL"
};

const displayTextKeys = {
    [SUBSCRIPTION_STATUS.PREMIUM]: "Premium",
    [SUBSCRIPTION_STATUS.FREEMIUM]: "Freemium",
    [SUBSCRIPTION_STATUS.ALL]: "All"
};

const labelClass = {
    [SUBSCRIPTION_STATUS.PREMIUM]: "cs-badge-premium",
    [SUBSCRIPTION_STATUS.FREEMIUM]: "cs-badge-freemium",
    [SUBSCRIPTION_STATUS.ALL]: "cs-badge-all"
};

export default injectBaseConstantMethods(SUBSCRIPTION_STATUS, displayTextKeys, labelClass);
